import Logan from "logan-sdk-custom"

export function loganLog(msg, type = 1) {
  console.error(msg)
  Logan.log(msg, type)
}
